import { track } from 'react-tracking';
import { isIdentityAvailable } from "./utils/identity";

/**
 *
 * @param globalTrackedData
 * @param dispatcher
 * @returns
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export var EventTracker = function EventTracker(globalTrackedData, dispatcher) {
  // Abstract and delegate tracking to underlaying 'react-tracking' NPM library
  // https://www.npmjs.com/package/react-tracking
  // https://open.nytimes.com/introducing-react-tracking-declarative-tracking-for-react-apps-2c76706bb79a
  return track(globalTrackedData, dispatcher);
};

/**
 *
 * @returns
 */
export var isEventTrackerReady = function isEventTrackerReady() {
  return !!isIdentityAvailable();
};